const validateRunWorkflow = ({ step }) => {
  if (step?.type === 'trigger') {
    const value = step?.options?.allowConcurrentRuns;
    return value === undefined || typeof value === 'boolean' ? { status: 'valid' } : { status: 'invalid', message: 'Allow concurrent runs must be a boolean.' };
  }

  const workflowId = step?.options?.workflowId;

  if (!workflowId) {
    return { status: 'invalid', message: 'Select a workflow' };
  }

  return { status: 'valid' };
};

export default validateRunWorkflow;
